import { Component, OnInit } from '@angular/core';
import { FileUploadComponent } from '../../../common/shared/components/file-upload/file-upload.component';
import { FileRestrictions } from '@progress/kendo-angular-upload';
import { ControlValueAccessor } from '@angular/forms';
import { LoadingService } from '../../../common/layout/loading.service';

@Component({
    selector: 'ns-my-documents-file-upload',
    templateUrl: './my-documents-file-upload.component.html',
    styleUrls: ['./my-documents-file-upload.component.scss'],
})
export class MyDocumentsFileUploadComponent extends FileUploadComponent implements OnInit, ControlValueAccessor {

    public fileRestrictions: FileRestrictions = {
        minFileSize: 1,
        allowedExtensions: ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.png', '.jpg', '.jpeg']
    };

    public extensionError = 'Dozwolone formaty plików to: \'.pdf\', \'.doc\', \'.docx\', \'.xls\', \'.xlsx\', \'.png\', \'.jpg\', \'.jpeg\'';
    public showExtensionError = false;

    constructor(
        protected loadingService: LoadingService
    ) {
        super(loadingService);
    }

    ngOnInit(): void {
    }

    public showErros(files) {
        if (
            files &&
            files.length &&
            files[0].validationErrors &&
            files[0].validationErrors.length &&
            files[0].validationErrors[0] === 'invalidFileExtension'
        ) {
            this.showExtensionError = true;
        } else {
            this.showExtensionError = false;
        }
    }
}
